export default __webpack_public_path__ + "static/media/AddressImage.cc26f43d.svg";